import { startExternalPasswordReset } from '@/api/auth';
import { logout } from '.';
import { handleError } from '../common';

export default async (email: string) => {
  await logout();
  try {
    await startExternalPasswordReset(email);
  } catch (error) {
    handleError(error);
  }
  return false;
};